export default "__VITE_ASSET__CUcLVYwE__"